// extracted by mini-css-extract-plugin
export default {"statusContainer":"Status_statusContainer__p2CHB","text":"Status_text__RKc0N"};